import pubsub from "@viewlift/pubsub";
import request from "graphql-request"
import localforage from "localforage";
import { getToken,getDeviceId, handleStatusGaCalls } from "../../../../helpers";
import { updateAuthorisationStore } from "../../../../MFEs/web-authentication-sdk/src/updateStore";
import { isTveLoggedInRoute } from "../../../../components/DynamicRoutes";
import Cookies from 'js-cookie';
import { triggerTveBeaconEvents } from "./helper";

const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
const tveProvider = window.app_data.appcmsPlatform.tveSettings.tveProvider

const query = `mutation ($site: String!, $input: SignInTveInput!) {
    identitySignInTve(site: $site, input: $input) {
      userId
      tveUserId
      provider
      providers
      idpName
      idpLogo
      planId
    }
  }`

export const registerTveUser = ({tveUserId=null,mvpd,zip=null,encryptedZip=null,path='/',resourceIds,setIsLoading}) => {
  if(window.cancel){
    return 
  }
    window.cancel = true;
    const generateId = _ => {
        const s4 = _ => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
    }	
    let deviceId = getDeviceId();
    let endpoint = `${apiBaseUrl}/graphql`
    localforage.getItem('AuthenticationStore').then((AuthenticationStore) =>{
    let user = AuthenticationStore?.user
    let variables = {
        'site': (window?.app_data?.site?.siteInternalName) || null,
        "input": {
          "mvpdProvider":mvpd,
          "provider": mvpd,
          "userId": user?.userId,
          "idpName": mvpd,
          "email":user?.email || '',
          "platform": "web_browser",
          "device": "web_browser",
          "deviceName": "WEB",
          "deviceId": deviceId,
          "channelIds":resourceIds,
          "tveUserId":tveUserId || user?.userId
        },
      }

      // if(tveUserId !== null || tveUserId !== undefined){
      //   variables.input.tveUserId = tveUserId
      // }
    
      if(zip !== null || zip !== undefined){
        variables.input["adobeMetadata"] = {
          zip
        }
      }
      
      if(encryptedZip !== null || encryptedZip !== undefined){
        variables.input["adobeMetadata"] = {
          ...variables.input["adobeMetadata"],
          encryptedZip
        }
      }


    getToken((token) => {

      let contentApiHeaders = {
        'x-api-key': window?.xApiKey,
        authorization: token

      }
      triggerTveBeaconEvents('TVE_LOGIN_SUCCESS')
      triggerTveBeaconEvents('TVE_VL_LOGIN_INIT')
      handleStatusGaCalls({eventName : 'tve_vl_login_init',subSection : null, type : 'tve', reason : mvpd, status : null, additionalLabel : null, action : 'VL Login Init', paymentStatus : null,eventCategory : 'Authentication',section : 'checkout'})
      handleStatusGaCalls({eventName : 'tve_provider_selected',tveProvider : window?.app_data?.appcmsPlatform?.tveSettings?.tveProvider, type : 'tve',  eventCategory : 'Authentication',section : 'checkout'})

      request(endpoint, query, variables,contentApiHeaders).then((res) => {
        window.cancel = false;
        const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
            let entitlementToken = localStorage.getItem('entitlementToken')
            let user = JSON.parse(entitlementToken)
            let mvpd = user?.mvpd || null
            let tveSuccessEventData = {
              "pageUrl": checkoutInitPageDetails?.pageUrl,
              "mvpdProvider": mvpd,
              "tveProvider": window?.app_data?.appcmsPlatform?.tveSettings?.tveProvider
          }
            triggerTveBeaconEvents('TVE_VL_LOGIN_SUCCESS')
            handleStatusGaCalls({eventName : 'tve_vl_login_success',subSection : null, type : 'tve', reason : tveSuccessEventData?.mvpdProvider, status : null, additionalLabel : null, action : 'VL Login Success', paymentStatus : null,eventCategory : 'Authentication',section : 'checkout'})
        let userAccessToken = Cookies.get('token') && JSON.parse(Cookies.get('token'))
          updateAuthorisationStore({userdetails:{...res?.identitySignInTve,...user,authorizationToken:userAccessToken?.authorizationToken,isSubscribed:false}})
          .then(() => {
            pubsub.publish('registerTVE',path)
          })
      })
      .catch((err) => {
          console.log(err)
          triggerTveBeaconEvents('TVE_VL_LOGIN_FAILURE')
          handleStatusGaCalls({eventName : 'tve_vl_login_failure',subSection : null, type : 'tve', reason : window?.app_data?.appcmsPlatform?.tveSettings?.tveProvider, status : null, additionalLabel : null, action : 'VL Login Failure', paymentStatus : null,eventCategory : 'Authentication',section : 'checkout'})
          window.cancel = false;
          setIsLoading(false);
          pubsub.publish('update-error-message',"error while connecting to TVE")
      })


    })
  })  
}